import { Injectable } from '@angular/core';

import { ProductLayout } from './dmo/product-layout';
import { ProductCategory } from './dmo/product-category';
import { Product } from './dmo/product';

@Injectable()
export class ProductConverterService {
  private readonly originalLayouts: any;
  private originalCategories: any;
  private originalProducts: any;

  constructor() {
    this.originalLayouts = {};
    this.originalCategories = {};
    this.originalProducts = {};
  }

  public combineLayoutsAndCategories(
    list: [Array<ProductLayout>, Array<ProductCategory>]
  ): Array<ProductLayout> {
    const layouts: Array<ProductLayout> = list[0];
    const categories: Array<ProductCategory> = list[1];
    return layouts
      .map((layout: ProductLayout) => {
        const categoryId: number = this.originalLayouts[layout.id].categoryId;
        if (categoryId && categoryId > 0) {
          layout.category = categories.find(
            (category: ProductCategory) => category.id === categoryId
          );
          // Remove all layouts that point to a category that doesn't exist anymore
          if (!layout.category) {
            layout = null;
          }
        } else {
          const productIds: Array<Number> = this.originalLayouts[layout.id]
            .productIds;
          layout.products = productIds.map(
            (oid: number) => this.originalProducts[oid]
          );
        }
        return layout;
      })
      .filter((layout: ProductLayout) => layout != null);
  }

  public convertLayoutJsonToDmo(layout: any): ProductLayout {
    this.originalLayouts[layout.oid] = layout;
    const productLayout: ProductLayout = new ProductLayout(
      layout.oid,
      layout.name
    );
    productLayout.description = layout.info;
    productLayout.image = layout.imageLocation;
    productLayout.visible = layout.visible;
    productLayout.relativeImage = layout.relativeImageLocation;
    return productLayout;
  }

  public convertLayoutDmoToJson(productLayout: ProductLayout): any {
    const layout: any = this.originalLayouts[productLayout.id];
    layout.info = productLayout.description;
    layout.imageLocation = productLayout.image;
    layout.visible = productLayout.visible;
    if (productLayout.category) {
      layout.categoryId = productLayout.category.id;
    }
    if (productLayout.products && productLayout.products.length > 0) {
      layout.productIds = productLayout.products.map(
        (product: Product) => product.id
      );
    }
    return layout;
  }

  public convertCategoryJsonToDmo(category: any): ProductCategory {
    this.originalCategories[category.oid] = category;
    const productCategory: ProductCategory = new ProductCategory(
      category.oid,
      category.name
    );
    productCategory.id = category.oid;
    productCategory.courseNumber = category.printOrder;
    productCategory.defaultDeliveryTax = category.deliveryVat;
    productCategory.defaultTakeawayTax = category.takeawayVat;
    productCategory.defaultTax = category.vat;
    productCategory.defaultTaxClassCode = category.taxClassCode;
    productCategory.description = category.info;
    productCategory.image = category.imageLocation;
    productCategory.name = category.name;
    productCategory.visible = category.visible;
    productCategory.relativeImage = category.relativeImageLocation;
    productCategory.products = category.products
      .filter(
        (product: any) =>
          product.manufacturer == null ||
          product.manufacturer === 'comboWithAdjustedPrices' ||
          product.manufacturer === ''
      )
      .map((product: any) => {
        this.originalProducts[product.oid] = product;
      });
    // TO-DO products, printertemplates, notificationtemplates, modifiers, timed-events
    return productCategory;
  }

  public convertCategoryDmoToJson(productCategory: ProductCategory): any {
    const category: any = this.originalCategories[productCategory.id];
    productCategory.id = category.oid = productCategory.id;
    category.printOrder = productCategory.courseNumber;
    category.deliveryVat = productCategory.defaultDeliveryTax;
    category.takeawayVat = productCategory.defaultTakeawayTax;
    category.vat = productCategory.defaultTax;
    category.taxClassCode = productCategory.defaultTaxClassCode;
    category.info = productCategory.description;
    category.imageLocation = productCategory.image;
    category.name = productCategory.name;
    category.visible = productCategory.visible;
    if (
      productCategory.printerTemplates &&
      productCategory.printerTemplates.length > 0
    ) {
      category.printTemplateIds = productCategory.printerTemplates.map(
        (template: any) => template.id
      );
    }
    if (
      productCategory.notificationTemplates &&
      productCategory.notificationTemplates.length > 0
    ) {
      category.notificationTemplateIds = productCategory.notificationTemplates.map(
        (template: any) => template.id
      );
    }
    if (productCategory.modifiers && productCategory.modifiers.length > 0) {
      category.additionIds = productCategory.modifiers.map(
        (modifier: any) => modifier.id
      );
    }
    // TO-DO products, timed-events
    return category;
  }
}
